import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface SectionHeadingProps {
  icon: string;
  title: string;
  subtitle?: string;
  moreLink?: string;
  moreText?: string;
  children?: ReactNode;
}

export default function SectionHeading({
  icon,
  title,
  subtitle,
  moreLink,
  moreText = "查看更多",
  children,
}: SectionHeadingProps) {
  return (
    <div className="mb-5 flex flex-wrap items-end justify-between gap-3 md:mb-7">
      <div className="flex items-center gap-3">
        <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
          <i className={`${icon} text-lg`} />
        </span>
        <div>
          <h2 className="text-lg font-semibold text-foreground-950 md:text-xl">{title}</h2>
          {subtitle && <p className="mt-0.5 text-xs text-foreground-500 md:text-sm">{subtitle}</p>}
        </div>
      </div>
      <div className="flex items-center gap-3">
        {children}
        {moreLink && (
          <Link
            to={moreLink}
            className="group flex items-center gap-1 whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600"
          >
            {moreText}
            <i className="ri-arrow-right-s-line text-lg transition-transform group-hover:translate-x-0.5" />
          </Link>
        )}
      </div>
    </div>
  );
}